// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"1d75f1a6","213":"9767e90f","239":"3d07b373","455":"4adcee5d","590":"4d94ec3c"}[chunkId] + ".chunk.js";
};